const CONSUMPTION_RADIO_GROUP_NAME = 'predefinedConsumption';

export { CONSUMPTION_RADIO_GROUP_NAME };
